import HcsButton from "./hcs-button";

export default class HcsButtonSaveConfiguration extends HcsButton {
    constructor(props) {
        super(props);
    }

    // override from base class
    buttonClick() {
        const { hcs } = this.props;

        this.disable();

        // We wait until (running) ECS callback has finished.
        // This is necessary because:
        // When the user enters the last required value inside a text field and immediately presses the "Next" button,
        // the blur event of the text field triggers the ECS callback, but the button "Next" event tells us that the current
        // configuration step has not yet been finished. This requires that the user has to press "Next" a second time.
        //
        // To avoid this we first wait for the text field callback, then we check if the current configuration step is ready to finish.
        // If not we show the warning message, otherwise we trigger the "Next" callback.
        this.props.configWait(["setCfgValue", "setSubCfgValue"], this).then(() => {
            let self = this;

            hcs.api.saveConfiguration({
                checkAuthentication: true,
                success: _ => {
                    self.enable();
                    super.triggerConfigurator();
                }
            });
        });
    }

    // override from base class
    isVisible() {
        return true;
    }

    buttonText() {
        return `<svg icon-id=\"icn-052-2-save\" version=\"2.0\">
                <use href=\"#icn-052-2-save\"></use>
            </svg>` + super.buttonText();
    }

    buttonClasses() {
        let inputClasses = ["hcs-button", "hcs-secondary", "hcs-saveconfiguration"];

        return inputClasses;
    }
}